import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { MagentoObjectDataset } from 'app/model/dataset/magento.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'MagentoSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(MagentoObjectDataset) }
})
export class MagentoCopySource extends TabularCopySource {
}
